import * as React from 'react';
import { KpiCard, type KpiCardProps } from './kpi-card';
import { cn } from '../../lib/utils';

export interface StatGroupProps {
  stats: Array<KpiCardProps>;
  columns?: 2 | 3 | 4;
  className?: string;
}

const columnMap: Record<2 | 3 | 4, string> = {
  2: 'grid-cols-1 sm:grid-cols-2',
  3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
};

export const StatGroup = React.forwardRef<HTMLDivElement, StatGroupProps>(
  ({ stats, columns = 4, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'grid gap-4',
          columnMap[columns],
          className,
        )}
      >
        {stats.map((stat, idx) => (
          <KpiCard key={idx} {...stat} />
        ))}
      </div>
    );
  },
);

StatGroup.displayName = 'StatGroup';
